import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AddTagForm.styles';
import {
  TagValidations,
  TagFieldFormat,
  TagFieldNormalize
} from '../../../models';

import Button from '../../inputs/button/Button';
import Icon from '../../common/icon/Icon';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';
import FormGroup from '../formgroup/FormGroup';

export class AddTagForm extends Component {
  render() {
    const categories = this.props.categories;
    const groups = this.props.groups;
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('models.tag.name')}
          type="text"
          placeholder={I18n.t('models.tag.name')}
          component={FormField}
          maxLength="24"
          validate={[TagValidations.name]}
        />
        <div className={css(styles.idField)}>
          <Field
            name="macAddress"
            label={I18n.t('models.tag.id')}
            type="text"
            placeholder={I18n.t('models.tag.idPlaceholder')}
            readOnly={this.props.isEditing}
            component={FormField}
            validate={TagValidations.id}
            format={TagFieldFormat.id}
            normalize={TagFieldNormalize.id}
          />
          {this.props.isEditing && (
            <Icon
              value="trash"
              styles={styles.deleteIcon}
              onClick={this.props.onDelete}
            />
          )}
        </div>
        <FormGroup>
          <Field
            name="category"
            label={I18n.t('models.tag.category')}
            type="selectfilter"
            placeholder={I18n.t('models.tag.category')}
            component={FormField}
            options={
              categories
                ? [{ id: 'id-placeholder', name: 'category', label: '-- select a category --', value: '' }, ...categories.map(category => ({
                  ...category,
                  label: category.name,
                  value: category
                }))]
                : []
            }
            validate={TagValidations.category}
          />

          <Field
            name="group"
            label={I18n.t('models.tag.group')}
            type="selectfilter"
            placeholder={I18n.t('models.tag.group')}
            component={FormField}
            options={
              groups
                ? [{ id: 'id-placeholder', name: 'group', label: '-- select a group --', value: '' }, ...groups.map(group => ({
                  ...group,
                  label: group.name,
                  value: group
                }))]
                : []
            }
            validate={TagValidations.group}
          />

          <Field
            name="field1"
            label={I18n.t('models.tag.field1')}
            type="text"
            placeholder={I18n.t('models.tag.field')}
            component={FormField}
            validate={TagValidations.field1}
          />

          <Field
            name="field2"
            label={I18n.t('models.tag.field2')}
            type="text"
            placeholder={I18n.t('models.tag.field')}
            component={FormField}
            validate={TagValidations.field2}
          />
        </FormGroup>
        <FormActions>
          <Button>{I18n.t('add.save')}</Button>
          <Button
            styles={styles.flatButton}
            type="button"
            onClick={this.props.onCancel}
          >
            {I18n.t('cancel')}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
  form: 'addtag'
})(AddTagForm);



// WEBPACK FOOTER //
// ./src/components/forms/addtagform/AddTagForm.js